import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import { getLeadRowData } from 'helpers/leads';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import TableResponsive from 'components/layout/TableResponsive';

class Leads extends React.Component {
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      show,
      close,
      urlData,
      list,
    } = this.props;

    const headers = {
      pipeline: messages.pipeline,
      lead: messages.lead,
      assignee: messages.assignee,
      actions: messages.actions,
    };
    const rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const detailsUrl = appIntl.urlPrefix + 'account/leads/' + list.data.list[i].id;

      const rowData = getLeadRowData(list.data.list[i], messages, appIntl, () => this.handleRowClick(detailsUrl));
      delete rowData.client; // we do not need to show the client

      rows.push(rowData);
    }

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.leads}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="leads"
            url="/api/leads.json"
            urlData={urlData}
            list={list}
            sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
          >
            <div class="panel panel-transparent">
              <div class="panel-body no-padding">
                {list.pending ? <Loader /> : <TableResponsive headers={headers} rows={rows} hover />}
              </div>
            </div>
          </List>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.leads,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Leads)));
